import { render, staticRenderFns } from "./Zertifikate.vue?vue&type=template&id=0f443cc3"
import script from "./Zertifikate.vue?vue&type=script&lang=js"
export * from "./Zertifikate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports